export enum FormInputCard {
  value = 'value',
}

export enum ShowModalPayment {
  VALIDATE_CREDIT_CARD = 'validate_credit_card',
  VALIDATE_ERROR = 'validate_error',
}

export type ShouldShowModalProps = {
  value: ShowModalPayment;
  newTitle: string | React.ReactNode;
};

export enum CreditCardValidationStatus {
  NONE = 'NONE',
  CREATE_ORDER = 'CREATE_ORDER',
  VALIDATE_DATA = 'VALIDATE_DATA',
  VALIDATED = 'VALIDATED',
}
